import { LoadableAfterPaint } from '@confluence/loadable';

export const InspectPermissionsDialog = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InspectPermissionsDialog" */ '../src/InspectPermissionsDialog'
			)
		).InspectPermissionsDialog,
});
